import http from '../jslibs/axios/http';

//内容管理 轮播图列表
export const carouselList = ()=> (http.get('/v1/cms/Carousel'));

//内容管理 轮播图新增
export const addCarousel = data => (http.post('/v1/cms/Carousel', data));

//内容管理 删除轮播图
export const deleteCarousel = uuid => (http.delete(`/v1/cms/Carousel/${uuid}`));

//内容管理 轮播图详情
export const carouselDetail = uuid => (http.get(`/v1/cms/Carousel/${uuid}`));

//内容管理 编辑轮播图
export const editCarousel = data => (http.put(`/v1/cms/Carousel/${data.id}`, data));

